import * as React from "react"
import Hero from "../components/page/Hero";
import PreviewList from "../components/blog/PreviewList";

export interface IndexPageProps {

}

const IndexPage = () => {
  return (
    <>
      <Hero/>
      <PreviewList displayFlat={false}/>
    </>
  )
}

export default IndexPage
